// import { secsToPace } from "@/utils/timeUtil.js";


export const activityTypes = [
    {
        name: "Alpine Ski", value: "AlpineSki", id: "AlpineSki", color: "#1800EA", url: "running.png", hasGps: true, defaultBinSize: 3,
        fields: [
            { label: "Profile", field: "profile", hidden: true },
            { label: "Athlete", field: "athlete" },
            { label: "Distance", field: "distance", type: "number" },
            { label: "Average", field: "avg_distance", type: "number" },
            { label: "Longest", field: "longest", type: "number" },
            { label: "Avg Speed", field: "avg_speed", type: "number" },
            { label: "Elevation Gain", field: "elev_gain", type: "number" },
            { label: "Activities", field: "activities", type: "number" },
        ]
    },
    {
        name: "Backcountry ski", value: "BackcountrySki", id: "BackcountrySki", color: "#FF0000", url: "running.png", hasGps: true, defaultBinSize: 3,
        fields: [
            { label: "Profile", field: "profile", hidden: true },
            { label: "Athlete", field: "athlete" },
            { label: "Distance", field: "distance", type: "number" },
            { label: "Average", field: "avg_distance", type: "number" },
            { label: "Longest", field: "longest", type: "number" },
            { label: "Avg Speed", field: "avg_speed", type: "number" },
            { label: "Elevation Gain", field: "elev_gain", type: "number" },
            { label: "Activities", field: "activities", type: "number" },
        ]
    },
    {
        name: "Badminton", value: "Badminton", id: "Badminton", color: "#FF0000", url: "running.png", hasGps: false, defaultBinSize: 3,
        fields: [
            { label: "Profile", field: "profile", hidden: true },
            { label: "Athlete", field: "athlete" },
            { label: "Activities", field: "activities", type: "number" },
            { label: "Total time", field: "time", type: "number" },
        ]
    },
    {
        name: "Canoe", value: "Canoeing", id: "Canoeing", color: "#1800EA", url: "running.png", hasGps: true, defaultBinSize: 3,
        fields: [
            { label: "Profile", field: "profile", hidden: true },
            { label: "Athlete", field: "athlete" },
            { label: "Distance", field: "distance", type: "number" },
            { label: "Average", field: "avg_distance", type: "number" },
            { label: "Longest", field: "longest", type: "number" },
            { label: "Avg Speed", field: "avg_speed", type: "number" },
            { label: "Elevation Gain", field: "elev_gain", type: "number" },
            { label: "Activities", field: "activities", type: "number" },
        ]
    },
    {
        name: "CrossFit", value: "Crossfit", id: "Crossfit", color: "#1800EA", url: "running.png", hasGps: false, defaultBinSize: 3, fields: [
            { label: "Profile", field: "profile", hidden: true },
            { label: "Athlete", field: "athlete" },
            { label: "Activities", field: "activities", type: "number" },
            { label: "Total time", field: "time", type: "number" },
        ]
    },
    {
        name: "E-Bike Ride", value: "EBikeRide", id: "EBikeRide", color: "#F948C4", url: "running.png", hasGps: true, defaultBinSize: 3,
        fields: [
            { label: "Profile", field: "profile", hidden: true },
            { label: "Athlete", field: "athlete" },
            { label: "Distance", field: "distance", type: "number" },
            { label: "Average", field: "avg_distance", type: "number" },
            { label: "Longest", field: "longest", type: "number" },
            { label: "Avg Speed", field: "avg_speed", type: "number" },
            { label: "Elevation Gain", field: "elev_gain", type: "number" },
            { label: "Activities", field: "activities", type: "number" },
        ]
    },
    {
        name: "Elliptical", value: "Elliptical", id: "Elliptical", color: "#FF0000", url: "running.png", hasGps: false, defaultBinSize: 3, fields: [
            { label: "Profile", field: "profile", hidden: true },
            { label: "Athlete", field: "athlete" },
            { label: "Activities", field: "activities", type: "number" },
            { label: "Total time", field: "time", type: "number" },
        ]
    },
    {
        name: "Golf", value: "Golf", id: "Golf", color: "#FF0000", url: "running.png", hasGps: true, defaultBinSize: 3, fields: [
            { label: "Profile", field: "profile", hidden: true },
            { label: "Athlete", field: "athlete" },
            { label: "Activities", field: "activities", type: "number" },
            { label: "Total time", field: "time", type: "number" },
        ]
    },
    {
        name: "Handcycle", value: "Handcycle", id: "Handcycle", color: "#FF0000", url: "running.png", hasGps: true, defaultBinSize: 3,
        fields: [
            { label: "Profile", field: "profile", hidden: true },
            { label: "Athlete", field: "athlete" },
            { label: "Distance", field: "distance", type: "number" },
            { label: "Average", field: "avg_distance", type: "number" },
            { label: "Longest", field: "longest", type: "number" },
            { label: "Avg Speed", field: "avg_speed", type: "number" },
            { label: "Elevation Gain", field: "elev_gain", type: "number" },
            { label: "Activities", field: "activities", type: "number" },
        ]
    },
    {
        name: "HIIT", value: "HIIT", id: "HIIT", color: "#FF0000", url: "running.png", hasGps: false, defaultBinSize: 3,
        fields: [
            { label: "Profile", field: "profile", hidden: true },
            { label: "Athlete", field: "athlete" },
            { label: "Activities", field: "activities", type: "number" },
            { label: "Total time", field: "time", type: "number" },
        ]
    },
    {
        name: "Hike", value: "Hike", id: "Hike", color: "#39ff14", url: "running.png", hasGps: true, defaultBinSize: 3,
        fields: [
            { label: "Profile", field: "profile", hidden: true },
            { label: "Athlete", field: "athlete" },
            { label: "Total Distance", field: "distance", type: "number" },
            { label: "Average Distance", field: "avg_distance", type: "number" },
            { label: "Longest", field: "longest", type: "number" },
            { label: "Avg Pace (min/km)", field: "avg_pace", type: "number" },
            { label: "Elevation Gain", field: "elev_gain", type: "number" },
            { label: "Activities", field: "activities", type: "number" },
        ]
    },
    {
        name: "Ice Skate", value: "IceSkate", id: "IceSkate", color: "#1800EA", url: "running.png", hasGps: true, defaultBinSize: 3,
        fields: [
            { label: "Profile", field: "profile", hidden: true },
            { label: "Athlete", field: "athlete" },
            { label: "Distance", field: "distance", type: "number" },
            { label: "Average", field: "avg_distance", type: "number" },
            { label: "Longest", field: "longest", type: "number" },
            { label: "Avg Speed", field: "avg_speed", type: "number" },
            { label: "Elevation Gain", field: "elev_gain", type: "number" },
            { label: "Activities", field: "activities", type: "number" },
        ]
    },
    {
        name: "Inline Skate", value: "InlineSkate", id: "InlineSkate", color: "#1800EA", url: "running.png", hasGps: true, defaultBinSize: 3,
        fields: [
            { label: "Profile", field: "profile", hidden: true },
            { label: "Athlete", field: "athlete" },
            { label: "Distance", field: "distance", type: "number" },
            { label: "Average", field: "avg_distance", type: "number" },
            { label: "Longest", field: "longest", type: "number" },
            { label: "Avg Speed", field: "avg_speed", type: "number" },
            { label: "Activities", field: "activities", type: "number" },
        ]
    },
    {
        name: "Kayaking", value: "Kayaking", id: "Kayaking", color: "#1800EA", url: "running.png", hasGps: true, defaultBinSize: 3,
        fields: [
            { label: "Profile", field: "profile", hidden: true },
            { label: "Athlete", field: "athlete" },
            { label: "Distance", field: "distance", type: "number" },
            { label: "Average", field: "avg_distance", type: "number" },
            { label: "Longest", field: "longest", type: "number" },
            { label: "Avg Speed", field: "avg_speed", type: "number" },
            { label: "Activities", field: "activities", type: "number" },
        ]
    },
    {
        name: "Kitesurf", value: "Kitesurf", id: "Kitesurf", color: "#1800EA", url: "running.png", hasGps: true, defaultBinSize: 3,
        fields: [
            { label: "Profile", field: "profile", hidden: true },
            { label: "Athlete", field: "athlete" },
            { label: "Distance", field: "distance", type: "number" },
            { label: "Average", field: "avg_distance", type: "number" },
            { label: "Longest", field: "longest", type: "number" },
            { label: "Avg Speed", field: "avg_speed", type: "number" },
            { label: "Elevation Gain", field: "elev_gain", type: "number" },
            { label: "Activities", field: "activities", type: "number" },
        ]
    },
    {
        name: "Nordic Ski", value: "NordicSki", id: "NordicSki", color: "#1800EA", url: "running.png", hasGps: true, defaultBinSize: 3,
        fields: [
            { label: "Profile", field: "profile", hidden: true },
            { label: "Athlete", field: "athlete" },
            { label: "Distance", field: "distance", type: "number" },
            { label: "Average", field: "avg_distance", type: "number" },
            { label: "Longest", field: "longest", type: "number" },
            { label: "Avg Speed", field: "avg_speed", type: "number" },
            { label: "Elevation Gain", field: "elev_gain", type: "number" },
            { label: "Activities", field: "activities", type: "number" },
        ]
    },
    // {
    //     name: "Padel", value: "Padel", id: "Padel", color: "#FF0000", url: "running.png", hasGps: false, defaultBinSize: 3,
    //     fields: [
    //         { label: "Profile", field: "profile", hidden: true },
    //         { label: "Athlete", field: "athlete" },
    //         { label: "Activities", field: "activities", type: "number" },
    //         { label: "Total time", field: "time", type: "number" },
    //     ]
    // },
    {
        name: "Pickleball", value: "Pickleball", id: "Pickleball", color: "#FF0000", url: "running.png", hasGps: false, defaultBinSize: 3,
        fields: [
            { label: "Profile", field: "profile", hidden: true },
            { label: "Athlete", field: "athlete" },
            { label: "Activities", field: "activities", type: "number" },
            { label: "Total time", field: "time", type: "number" },
        ]
    },
    {
        name: "Pilates", value: "Pilates", id: "Pilates", color: "#FF0000", url: "running.png", hasGps: false, defaultBinSize: 3,
        fields: [
            { label: "Profile", field: "profile", hidden: true },
            { label: "Athlete", field: "athlete" },
            { label: "Activities", field: "activities", type: "number" },
            { label: "Total time", field: "time", type: "number" },
        ]
    },
    {
        name: "Racquetball", value: "Racquetball", id: "Racquetball", color: "#FF0000", url: "running.png", hasGps: false, defaultBinSize: 3,
        fields: [
            { label: "Profile", field: "profile", hidden: true },
            { label: "Athlete", field: "athlete" },
            { label: "Activities", field: "activities", type: "number" },
            { label: "Total time", field: "time", type: "number" },
        ]
    },
    {
        name: "Ride", value: "Ride", id: "Ride", color: "#ff073a", url: "running.png", hasGps: true, defaultBinSize: 10,
        fields: [
            { label: "Profile", field: "profile", hidden: true },
            { label: "Athlete", field: "athlete" },
            { label: "Distance", field: "distance", type: "number" },
            { label: "Average", field: "avg_distance", type: "number" },
            { label: "Longest", field: "longest", type: "number" },
            { label: "Avg Speed", field: "avg_speed", type: "number" },
            { label: "Elevation Gain", field: "elev_gain", type: "number" },
            { label: "Activities", field: "activities", type: "number" },
        ]
    },
    {
        name: "Rock Climbing", value: "RockClimbing", id: "RockClimbing", color: "#FF0000", url: "running.png", hasGps: false, defaultBinSize: 3,
        fields: [
            { label: "Profile", field: "profile", hidden: true },
            { label: "Athlete", field: "athlete" },
            { label: "Activities", field: "activities", type: "number" },
            { label: "Total time", field: "time", type: "number" },
        ]
    },
    {
        name: "Roller Ski", value: "RollerSki", id: "RollerSki", color: "#1800EA", url: "running.png", hasGps: true, defaultBinSize: 3,
        fields: [
            { label: "Profile", field: "profile", hidden: true },
            { label: "Athlete", field: "athlete" },
            { label: "Distance", field: "distance", type: "number" },
            { label: "Average", field: "avg_distance", type: "number" },
            { label: "Longest", field: "longest", type: "number" },
            { label: "Avg Speed", field: "avg_speed", type: "number" },
            { label: "Elevation Gain", field: "elev_gain", type: "number" },
            { label: "Activities", field: "activities", type: "number" },
        ]
    },
    {
        name: "Rowing", value: "Rowing", id: "Rowing", color: "#C04CFD", url: "running.png", hasGps: true, defaultBinSize: 3,
        fields: [
            { label: "Profile", field: "profile", hidden: true },
            { label: "Athlete", field: "athlete" },
            { label: "Distance", field: "distance", type: "number" },
            { label: "Average", field: "avg_distance", type: "number" },
            { label: "Longest", field: "longest", type: "number" },
            { label: "Avg Speed", field: "avg_speed", type: "number" },
            { label: "Elevation Gain", field: "elev_gain", type: "number" },
            { label: "Activities", field: "activities", type: "number" },
        ]
    },
    {
        name: "Run", value: "Run", id: "Run", color: "#3cfff3", url: "running.png", hasGps: true, defaultBinSize: 3,
        fields: [
            { label: "Profile", field: "profile", hidden: true },
            { label: "Athlete", field: "athlete" },
            { label: "Total", field: "distance", type: "number" },
            { label: "Average Distance", field: "avg_distance", type: "number" },
            { label: "Average Weekly", field: "avg_weekly_distance", type: "number" },
            { label: "Longest", field: "longest", type: "number" },
            { label: "Avg Pace (min/km)", field: "avg_pace", type: "number" },
            { label: "Elevation Gain", field: "elev_gain", type: "number" },
            { label: "Activities", field: "activities", type: "number" },
        ]
    },
    {
        name: "Sail", value: "Sail", id: "Sail", color: "#C04CFD", url: "running.png", hasGps: true, defaultBinSize: 3, fields: [
            { label: "Profile", field: "profile", hidden: true },
            { label: "Athlete", field: "athlete" },
            { label: "Distance", field: "distance", type: "number" },
            { label: "Average", field: "avg_distance", type: "number" },
            { label: "Longest", field: "longest", type: "number" },
            { label: "Avg Speed", field: "avg_speed", type: "number" },
            { label: "Elevation Gain", field: "elev_gain", type: "number" },
            { label: "Activities", field: "activities", type: "number" },
        ]
    },
    {
        name: "Skateboard", value: "Skateboard", id: "Skateboard", color: "#C04CFD", url: "running.png", hasGps: true, defaultBinSize: 3,
        fields: [
            { label: "Profile", field: "profile", hidden: true },
            { label: "Athlete", field: "athlete" },
            { label: "Distance", field: "distance", type: "number" },
            { label: "Average", field: "avg_distance", type: "number" },
            { label: "Longest", field: "longest", type: "number" },
            { label: "Avg Speed", field: "avg_speed", type: "number" },
            { label: "Elevation Gain", field: "elev_gain", type: "number" },
            { label: "Activities", field: "activities", type: "number" },
        ]
    },
    {
        name: "Snowboard", value: "Snowboard", id: "Snowboard", color: "#C04CFD", url: "running.png", hasGps: true, defaultBinSize: 3,
        fields: [
            { label: "Profile", field: "profile", hidden: true },
            { label: "Athlete", field: "athlete" },
            { label: "Distance", field: "distance", type: "number" },
            { label: "Average", field: "avg_distance", type: "number" },
            { label: "Longest", field: "longest", type: "number" },
            { label: "Avg Speed", field: "avg_speed", type: "number" },
            { label: "Elevation Gain", field: "elev_gain", type: "number" },
            { label: "Activities", field: "activities", type: "number" },
        ]
    },
    {
        name: "Snowshoe", value: "Snowshoe", id: "Snowshoe", color: "#C04CFD", url: "running.png", hasGps: true, defaultBinSize: 3,
        fields: [
            { label: "Profile", field: "profile", hidden: true },
            { label: "Athlete", field: "athlete" },
            { label: "Total Distance", field: "distance", type: "number" },
            { label: "Average Distance", field: "avg_distance", type: "number" },
            { label: "Longest", field: "longest", type: "number" },
            { label: "Avg Pace (min/km)", field: "avg_pace", type: "number" },
            { label: "Elevation Gain", field: "elev_gain", type: "number" },
            { label: "Activities", field: "activities", type: "number" },
        ]
    },
    {
        name: "Soccer", value: "Soccer", id: "Soccer", color: "#C04CFD", url: "running.png", hasGps: true, defaultBinSize: 3,
        fields: [
            { label: "Profile", field: "profile", hidden: true },
            { label: "Athlete", field: "athlete" },
            { label: "Total Distance", field: "distance", type: "number" },
            { label: "Average Distance", field: "avg_distance", type: "number" },
            { label: "Longest", field: "longest", type: "number" },
            { label: "Avg Pace (min/km)", field: "avg_pace", type: "number" },
            { label: "Elevation Gain", field: "elev_gain", type: "number" },
            { label: "Activities", field: "activities", type: "number" },
        ]
    },
    {
        name: "Stair-Stepper", value: "StairStepper", id: "StairStepper", color: "#C04CFD", url: "running.png", hasGps: false, defaultBinSize: 3, fields: [
            { label: "Profile", field: "profile", hidden: true },
            { label: "Athlete", field: "athlete" },
            { label: "Activities", field: "activities", type: "number" },
            { label: "Total time", field: "time", type: "number" },
        ]
    },
    {
        name: "Stand Up Paddling", value: "StandUpPaddling", id: "StandUpPaddling", color: "#C04CFD", url: "running.png", hasGps: true, defaultBinSize: 3,
        fields: [
            { label: "Profile", field: "profile", hidden: true },
            { label: "Athlete", field: "athlete" },
            { label: "Distance", field: "distance", type: "number" },
            { label: "Average", field: "avg_distance", type: "number" },
            { label: "Longest", field: "longest", type: "number" },
            { label: "Avg Speed", field: "avg_speed", type: "number" },
            { label: "Elevation Gain", field: "elev_gain", type: "number" },
            { label: "Activities", field: "activities", type: "number" },
        ]
    },
    {
        name: "Surfing", value: "Surfing", id: "Surfing", color: "#C04CFD", url: "running.png", hasGps: true, defaultBinSize: 3, fields: [
            { label: "Profile", field: "profile", hidden: true },
            { label: "Athlete", field: "athlete" },
            { label: "Distance", field: "distance", type: "number" },
            { label: "Average", field: "avg_distance", type: "number" },
            { label: "Longest", field: "longest", type: "number" },
            { label: "Avg Speed", field: "avg_speed", type: "number" },
            { label: "Elevation Gain", field: "elev_gain", type: "number" },
            { label: "Activities", field: "activities", type: "number" },
        ]
    },
    {
        name: "Swim", value: "Swim", id: "Swim", color: "#48F97C", url: "running.png", hasGps: true, defaultBinSize: 3,
        fields: [
            { label: "Profile", field: "profile", hidden: true },
            { label: "Athlete", field: "athlete" },
            { label: "Distance", field: "distance", type: "number" },
            { label: "Average", field: "avg_distance", type: "number" },
            { label: "Longest", field: "longest", type: "number" },
            { label: "Avg Speed", field: "avg_speed", type: "number" },
            { label: "Elevation Gain", field: "elev_gain", type: "number" },
            { label: "Activities", field: "activities", type: "number" },
        ]
    },
    {
        name: "Squash", value: "Squash", id: "Squash", color: "#FF0000", url: "running.png", hasGps: false, defaultBinSize: 3,
        fields: [
            { label: "Profile", field: "profile", hidden: true },
            { label: "Athlete", field: "athlete" },
            { label: "Activities", field: "activities", type: "number" },
            { label: "Total time", field: "time", type: "number" },
        ]
    },
    {
        name: "Table Tennis", value: "TableTennis", id: "TableTennis", color: "#FF0000", url: "running.png", hasGps: false, defaultBinSize: 3,
        fields: [
            { label: "Profile", field: "profile", hidden: true },
            { label: "Athlete", field: "athlete" },
            { label: "Activities", field: "activities", type: "number" },
            { label: "Total time", field: "time", type: "number" },
        ]
    },
    {
        name: "Tennis", value: "Tennis", id: "Tennis", color: "#FF0000", url: "running.png", hasGps: false, defaultBinSize: 3,
        fields: [
            { label: "Profile", field: "profile", hidden: true },
            { label: "Athlete", field: "athlete" },
            { label: "Activities", field: "activities", type: "number" },
            { label: "Total time", field: "time", type: "number" },
        ]
    },
    {
        name: "Velomobile", value: "Velomobile", id: "Velomobile", color: "#C04CFD", url: "running.png", hasGps: true, defaultBinSize: 3,
        fields: [
            { label: "Profile", field: "profile", hidden: true },
            { label: "Athlete", field: "athlete" },
            { label: "Distance", field: "distance", type: "number" },
            { label: "Average", field: "avg_distance", type: "number" },
            { label: "Longest", field: "longest", type: "number" },
            { label: "Avg Speed", field: "avg_speed", type: "number" },
            { label: "Elevation Gain", field: "elev_gain", type: "number" },
            { label: "Activities", field: "activities", type: "number" },
        ]
    },
    {
        name: "Virtual Ride", value: "VirtualRide", id: "VirtualRide", color: "#FF0000", url: "running.png", hasGps: true, defaultBinSize: 10,
        fields: [
            { label: "Profile", field: "profile", hidden: true },
            { label: "Athlete", field: "athlete" },
            { label: "Distance", field: "distance", type: "number" },
            { label: "Average", field: "avg_distance", type: "number" },
            { label: "Longest", field: "longest", type: "number" },
            { label: "Avg Speed", field: "avg_speed", type: "number" },
            { label: "Elevation Gain", field: "elev_gain", type: "number" },
            { label: "Activities", field: "activities", type: "number" },
        ]
    },
    {
        name: "Virtual Run", value: "VirtualRun", id: "VirtualRun", color: "#C04CFD", url: "running.png", hasGps: true, defaultBinSize: 3,
        fields: [
            { label: "Profile", field: "profile", hidden: true },
            { label: "Athlete", field: "athlete" },
            { label: "Total", field: "distance", type: "number" },
            { label: "Average Distance", field: "avg_distance", type: "number" },
            { label: "Average Weekly", field: "avg_weekly_distance", type: "number" },
            { label: "Longest", field: "longest", type: "number" },
            { label: "Avg Pace (min/km)", field: "avg_pace", type: "number" },
            { label: "Elevation Gain", field: "elev_gain", type: "number" },
            { label: "Activities", field: "activities", type: "number" },
        ]
    },
    {
        name: "Walk", value: "Walk", id: "Walk", color: "#ffa500", url: "running.png", hasGps: true, defaultBinSize: 3,
        fields: [
            { label: "Profile", field: "profile", hidden: true },
            { label: "Athlete", field: "athlete" },
            { label: "Total Distance", field: "distance", type: "number" },
            { label: "Average Distance", field: "avg_distance", type: "number" },
            { label: "Longest", field: "longest", type: "number" },
            { label: "Avg Pace (min/km)", field: "avg_pace", type: "number" },
            { label: "Elevation Gain", field: "elev_gain", type: "number" },
            { label: "Activities", field: "activities", type: "number" },
            // { label: "Total time", field: "time", type: "number" },
        ]
    },
    {
        name: "Weight Training", value: "WeightTraining", id: "WeightTraining", color: "#C04CFD", url: "running.png", hasGps: false, defaultBinSize: 3, fields: [
            { label: "Profile", field: "profile", hidden: true },
            { label: "Athlete", field: "athlete" },
            { label: "Activities", field: "activities", type: "number" },
            { label: "Total time", field: "time", type: "number" },
        ]
    },
    {
        name: "Wheelchair", value: "Wheelchair", id: "Wheelchair", color: "#C04CFD", url: "running.png", hasGps: true, defaultBinSize: 3, fields: [
            { label: "Profile", field: "profile", hidden: true },
            { label: "Athlete", field: "athlete" },
            { label: "Distance", field: "distance", type: "number" },
            { label: "Average", field: "avg_distance", type: "number" },
            { label: "Longest", field: "longest", type: "number" },
            { label: "Avg Speed", field: "avg_speed", type: "number" },
            { label: "Elevation Gain", field: "elev_gain", type: "number" },
            { label: "Activities", field: "activities", type: "number" },
        ]
    },
    {
        name: "Windsurf", value: "Windsurf", id: "Windsurf", color: "#C04CFD", url: "running.png", hasGps: true, defaultBinSize: 3,
        fields: [
            { label: "Profile", field: "profile", hidden: true },
            { label: "Athlete", field: "athlete" },
            { label: "Distance", field: "distance", type: "number" },
            { label: "Average", field: "avg_distance", type: "number" },
            { label: "Longest", field: "longest", type: "number" },
            { label: "Avg Speed", field: "avg_speed", type: "number" },
            { label: "Elevation Gain", field: "elev_gain", type: "number" },
            { label: "Activities", field: "activities", type: "number" },
        ]
    },
    {
        name: "Workout", value: "Workout", id: "Workout", color: "#C0DA74", url: "running.png", hasGps: false, defaultBinSize: 3,
        fields: [
            { label: "Profile", field: "profile", hidden: true },
            { label: "Athlete", field: "athlete" },
            { label: "Activities", field: "activities", type: "number" },
            { label: "Total time", field: "time", type: "number" },
        ]
    },
    {
        name: "Yoga", value: "Yoga", id: "Yoga", color: "#1800EA", url: "running.png", hasGps: false, defaultBinSize: 3,
        fields: [
            { label: "Profile", field: "profile", hidden: true },
            { label: "Athlete", field: "athlete" },
            { label: "Activities", field: "activities", type: "number" },
            { label: "Total time", field: "time", type: "number" },
        ]
    },
]
